// rc4.0登录页相关
const { hostname } = window.location;

export const IS_TAG_IT_SOURCE = /tagitprotection/.test(hostname);

export const EMAIL_ADDRESS = {
  seel: IS_TAG_IT_SOURCE ? 'support@tagitprotection.com' : 'support@seel.com',
  merchant: IS_TAG_IT_SOURCE ? 'support@tagitprotection.com' : 'merchant@seel.com',
};

export const RETURN_ORDER_SERVICE_PATH = '/controller/resolutioncenter/orderservice/';

// customer portal sub path
export const customerSubPath = 'customer-portal';
